import {
  IconBook,
  IconCalendar2,
  IconHome,
  IconHome1,
  IconList,
  IconOffer,
  IconPrinter,
  IconShoppingCart,
  IconUsers,
  IconOffer1,
  IconBook1,
  IconShoppingCart1,
  IconPDF,
  IconPrinter1
} from "./icons/Icon";
import Home from "./view/protected-pages/general/Home";
import HomeAdmin from "./view/protected-pages/admin/Home";
import UsersAdmin from "./view/protected-pages/admin/Users";
import MenuSkirtsAdmin from "./view/protected-pages/admin/MenuSkirts";
import PromotionsAdmin from "./view/protected-pages/admin/Promotions";
import LoadSkirtsViewAdmin from "./view/protected-pages/admin/LoadSkirtsView";
import ManualsAdmin from "./view/protected-pages/admin/Manuals";
import CatalogsAdmin from "./view/protected-pages/admin/Catalogs";
import ReportsAdmin from "./view/protected-pages/admin/Reports";
import Promotions from "./view/protected-pages/general/Promotions";
import Skirt from "./view/protected-pages/general/Skirt";
import Calendar from "./view/protected-pages/general/Calendar";
import Manuals from "./view/protected-pages/general/Manuals";
import Catalogs from "./view/protected-pages/general/Catalogs";
import Notifications from "./view/protected-pages/general/Notifications";
import Seeker from "./view/protected-pages/general/Seeker";


const routes = [
  {
    id: 1,
    parent: 0,
    title: "Home",
    path: "home",
    index: true,
    Component: Home,
    Icon: IconHome,
    isMenu: true,
  },
  {
    id: 2,
    parent: 0,
    title: "Promociones",
    path: "promotions",
    Component: Promotions,
    Icon: IconOffer,
    isMenu: true,
  },
  {
    id: 3,
    parent: 0,
    title: "Faldones",
    path: "skirt",
    Component: Skirt,
    Icon: IconPrinter,
    isMenu: true,
    children: [],
  },
  {
    id: 4,
    parent: 0,
    title: "Calendario",
    path: "calendar",
    Component: Calendar,
    Icon: IconCalendar2,
    isMenu: true,
  },
  {
    id: 5,
    parent: 0,
    title: "Manuales",
    path: "manuals",
    Component: Manuals,
    Icon: IconBook,
    isMenu: true,
  },
  {
    id: 6,
    parent: 0,
    title: "Cátalogos",
    path: "catalogs",
    Component: Catalogs,
    Icon: IconShoppingCart,
    isMenu: true,
  },
  {
    id: 7,
    parent: 0,
    title: "Notificaciones",
    path: "notifications",
    Component: Notifications,
    isMenu: false,
  },
  {
    id: 8,
    parent: 0,
    title: "",
    path: "seeker",
    Component: Seeker,
    isMenu: false,
  },
];

const routesAdmin = [
  {
    id: "home",
    title: "Home",
    path: "home",
    Component: HomeAdmin,
    Icon: (props) => <IconHome1 {...props} />,
    isMenu: true,
  },
  {
    id: "users",
    title: "Administrar Usuarios",
    path: "users",
    Component: UsersAdmin,
    Icon: (props) => <IconUsers {...props} />,
    isMenu: true,
  },
  {
    id: "menu-skirts",
    title: "Menú Faldones",
    path: "menu-skirts",
    Component: MenuSkirtsAdmin,
    Icon: (props) => <IconList {...props} />,
    isMenu: true,
  },
  {
    id: "promotions",
    title: "Cargar Promociones",
    path: "promotions",
    Component: PromotionsAdmin,
    Icon: (props) => <IconOffer1 {...props} />,
    isMenu: true,
  },
  {
    id: "load-skirts",
    title: "Cargar Faldones",
    path: "load-skirts",
    Component: LoadSkirtsViewAdmin,
    Icon: (props) => <IconPDF {...props} />,
    isMenu: true,
  },
  {
    id: "manuals",
    title: "Cargar Manuales",
    path: "manuals",
    Component: ManualsAdmin,
    Icon: (props) => <IconBook1 {...props} />,
    isMenu: true,
  },
  {
    id: "catalogs",
    title: "Cargar Catálogo",
    path: "catalogs",
    Component: CatalogsAdmin,
    Icon: (props) => <IconShoppingCart1 {...props} />,
    isMenu: true,
  },
  {
    id: "reports",
    title: "Reportes",
    path: "reports",
    Component: ReportsAdmin,
    Icon: (props) => <IconPrinter1 {...props} />,
    isMenu: true,
  },
];

export { routes, routesAdmin };
